import React from 'react'
import { Tab, Tabs, TabList, TabPanel, TabPanels } from '@chakra-ui/react'

import { useDimensionListQuery } from 'modules/dimensions'

export const DimensionDataTabs = ({ children, ...props }) => {
  const { data = [] } = useDimensionListQuery()

  return (
    <Tabs>
      <TabList>
        {data.map(({ id, name }, index) => (
          <Tab key={index}>{name}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {data.map((dimension, index) => (
          <TabPanel px={0} py={4} key={index}>
            {children(dimension)}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  )
}

export default DimensionDataTabs
